module.exports = __webpack_public_path__ + "static/media/icon-manage-class-change-class.6aa2764d.svg";